import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'roles',
    collectionActionName: 'APM_ROLES',
    itemActionName: 'APM_ROLE',
});
